module.exports = __webpack_public_path__ + "static/img/hz52.765cb9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz52.png
// module id = 9AdH
// module chunks = 77